import React, { createContext, useContext, useReducer, useRef } from 'react';
export var ActionType;
(function (ActionType) {
    ActionType["NOTIFY_PARTICIPANT_SPEAKING"] = "NOTIFY_PARTICIPANT_SPEAKING";
    ActionType["SET_VISIBLE_ATTENDEES_COUNT"] = "SET_VISIBLE_ATTENDEES_COUNT";
    ActionType["SET_SELECTED_PAGE"] = "SET_SELECTED_PAGE";
})(ActionType || (ActionType = {}));
export const initialState = {
    latestSpeaker: {
        date: 0,
        id: '',
    },
    selectedPage: 1,
    visibleAttendeesCount: -1,
};
export const AttendeesOrderContext = createContext({
    dispatch: () => { },
    state: initialState,
});
AttendeesOrderContext.displayName = 'AttendeesOrderContext';
function AttendeesOrderReducer(state, action) {
    switch (action.type) {
        case ActionType.NOTIFY_PARTICIPANT_SPEAKING:
            return Object.assign(Object.assign({}, state), { latestSpeaker: { id: action.value || '', date: Date.now() } });
        case ActionType.SET_SELECTED_PAGE:
            return Object.assign(Object.assign({}, state), { selectedPage: action.value || 1 });
        case ActionType.SET_VISIBLE_ATTENDEES_COUNT:
            return Object.assign(Object.assign({}, state), { visibleAttendeesCount: action.value || -1 });
        default:
            return state;
    }
}
function AttendeesOrder(props) {
    const [state, dispatch] = useReducer(AttendeesOrderReducer, initialState);
    return (React.createElement(AttendeesOrderContext.Provider, { value: { dispatch, state } }, props.children));
}
export function useOrderedAttendees(attendees) {
    const latestOrderedAttendeesIds = useRef(attendees.map(({ id }) => id));
    const { state } = useContext(AttendeesOrderContext);
    const orderedAttendees = getOrderedAttendees(attendees, state, latestOrderedAttendeesIds.current);
    latestOrderedAttendeesIds.current = orderedAttendees.map(({ id }) => id);
    return orderedAttendees;
}
function getOrderedAttendees(attendees, state, latestOrderedAttendeesIds) {
    function mapAttendees(indexedAttendees, orderedIds) {
        return orderedIds.reduce((acc, id) => {
            if (indexedAttendees[id]) {
                acc.push(indexedAttendees[id]);
            }
            return acc;
        }, []);
    }
    function switchAttendeeToFirstPositionAndMap(indexedAttendees, orderedIds) {
        return orderedIds.reduce((acc, attendeeId) => {
            if (attendeeId === state.latestSpeaker.id) {
                acc.unshift(indexedAttendees[attendeeId]);
            }
            else {
                acc.push(indexedAttendees[attendeeId]);
            }
            return acc;
        }, []);
    }
    // INDEX THE ATTENDEES FOR LATER FASTEST ACCESS
    const indexedAttendees = [];
    attendees.forEach((attendee) => {
        indexedAttendees[attendee.id] = attendee;
        // ADD TO THE ATTENDEEIDS THE NEW ONES
        if (!latestOrderedAttendeesIds.includes(attendee.id)) {
            latestOrderedAttendeesIds.push(attendee.id);
        }
    });
    // LET'S REMOVE THE IDS OF THE ATTENDEES THAT ARE NO LONGER HERE
    latestOrderedAttendeesIds = latestOrderedAttendeesIds.filter((id) => !!indexedAttendees[id]);
    // IF THE SPEAKING ATTENDEE IS ALREADY IN FIRST POSITION OR THE USER IS NOT IN THE FIRST PAGE, RETURN THE ARRAY AS IT IS
    if (!state.latestSpeaker ||
        !latestOrderedAttendeesIds.length ||
        latestOrderedAttendeesIds[0] === state.latestSpeaker.id ||
        state.selectedPage !== 1) {
        return mapAttendees(indexedAttendees, latestOrderedAttendeesIds);
    }
    // LET'S CHECK IF THE SPEAKER IS IN THE FIRST PAGE
    // WE GET AN ARRAY OF THE ATTENDEESIDS THAT ARE IN THE FIRST PAGE
    const attendeesInPage = latestOrderedAttendeesIds.slice(0, state.visibleAttendeesCount);
    // IF THE SPEAKER IS IN THE CURRENT PAGE, RETURN THEM IN THE SAME ORDER
    if (attendeesInPage.includes(state.latestSpeaker.id)) {
        return mapAttendees(indexedAttendees, latestOrderedAttendeesIds);
    }
    // IF NOT, MOVE THE ATTENDEE TO THE FIRST POSITION AND RETURN THEM MAPPED
    return switchAttendeeToFirstPositionAndMap(indexedAttendees, latestOrderedAttendeesIds);
}
export function canUpdateDominantSpeaker(attendeesOrderState, volume, participantId) {
    let canUpdate = volume > 15 &&
        attendeesOrderState.latestSpeaker.id !== participantId &&
        attendeesOrderState.selectedPage === 1;
    if (canUpdate) {
        canUpdate = (Date.now() - attendeesOrderState.latestSpeaker.date) / 1000 > 2;
    }
    return canUpdate;
}
export default AttendeesOrder;
//# sourceMappingURL=AttendeesOrder.js.map